import { RestClient } from "./rest-client";

export const S3RestClient = new RestClient();
